var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hamburger",class:{open: _vm.open, dark: _vm.dark},attrs:{"id":"hamburger"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"patties"})])}
var staticRenderFns = []

export { render, staticRenderFns }